module.exports = __webpack_public_path__ + "img/66A183.049d325b.svg";